import { create } from 'zustand'

interface EmployeeRankingState {
  isOpen: boolean
  setIsOpen: (value: boolean) => void
  reset: () => void
}

export const useEmployeeRankingStore = create<EmployeeRankingState>(set => ({
  isOpen: false,
  setIsOpen: value => set({ isOpen: value }),
  reset: () => set({ isOpen: false })
}))
